export const shouldBeShippedToday = (now = new Date()) => {
  const day = now.getDay()
  const hour = now.getHours()

  // The delivery date is always next day on Sundays

  return hour < 13 && day !== 0
}

export const shouldRenderNowCountdown = (now = new Date()) => {
  const day = now.getDay()
  const hour = now.getHours()

  // No NOW countdown is shown Friday afternoon and Saturday

  switch (day) {
    case 5:
      return hour < 13
    case 6:
      return false
    default:
      return true
  }
}

export const getProperTime = t => `${t}`.padStart(2, '0')

export const getCountdown = () => {
  const now = new Date()
  const hour = 13

  const countDownDate = new Date()

  countDownDate.setHours(hour)
  countDownDate.setMinutes(0)
  countDownDate.setSeconds(0)

  if (countDownDate.getDay() === 0) {
    countDownDate.setHours(23)
    countDownDate.setMinutes(59)
    countDownDate.setSeconds(59)
  } else if (now.getHours() >= hour) {
    countDownDate.setDate(countDownDate.getDate() + 1)
  }

  const distance = countDownDate.getTime() - now.getTime()

  const hours = getProperTime(
    Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  )
  const minutes = getProperTime(
    Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
  )
  const seconds = getProperTime(Math.floor((distance % (1000 * 60)) / 1000))
  return `${hours}:${minutes}:${seconds}`
}

export const showFreeDeliveryLabel = () => {
  const date = new Date()
  return date.getFullYear() === 2021
}
